import { graphql } from '@/generated/gql';

export const QUOTE_ANALYSIS_SUBSCRIPTION = graphql(/* GraphQL */ `
  subscription OnCompletedQuoteAnaylsis($id: UUID!) {
    sevenbridges {
      # TODO: Discuss whether adjustment on 7bridges is required
      quote {
        analysis(id: $id) {
          id
          fileId
          status
          quote {
            id
            quoteReference
            currency
            lineItems {
              id
              sequence
              position
              title
              description
              unitId
              pricePerUnit
              quantity
              earlyDeliveryAt
              lateDeliveryAt
            }
          }
        }
      }
    }
  }
`);
